import React, { useState } from 'react';

import { ListingsAvatarWithBadge } from './ListingsAvatarWithBadge';
import { ListingsVerifiedBadgeDialog } from './ListingsVerifiedBadgeDialog';
import { ILSClickableAvatarWithBadgeProps } from './types';

export const LSClickableAvatarWithBadge: React.FC<
    ILSClickableAvatarWithBadgeProps
> = ({ featureFlags, isMobile }) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleClick = () => {
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <ListingsAvatarWithBadge
                featureFlags={featureFlags}
                isMobile={isMobile}
                onClick={handleClick}
                verifiedBadgeIconSize={12}
            />
            {isDialogOpen && (
                <ListingsVerifiedBadgeDialog
                    isMobile={isMobile}
                    closeDialog={handleCloseDialog}
                    featureFlags={featureFlags}
                />
            )}
        </>
    );
};
